import $ from 'jquery';

import {renderAutocomplete} from './modules/autocomplete';
import {renderImageSlider} from './modules/imageSlider';
import {renderSearchTimelineCanvas} from './modules/searchTimelineCanvas';
import {renderSearchTimelineSlider} from './modules/searchTimelineSlider';

$(function () {
	renderSearchTimelineCanvas();
	renderSearchTimelineSlider();
	renderAutocomplete();
	renderImageSlider();

	$('.searchhelp').click(function (e) {
		e.preventDefault();
		$('.searchhelp').fadeOut(250);
	});

	$('.helptoggle').click(function (e) {
		e.preventDefault();
		$('.searchhelp').fadeToggle(250);
	});
});
